import React from 'react'

import { getAppConfig } from '@utils/getAppConfig'
import { getMarketingTrackingData } from '@utils/getMarketingTrackingData'

import useAppQueryState from '@hooks/useAppQueryState'
import { useBasin } from '@hooks/useBasin'

import { getAlternativeProductApplicationUrl } from '../utils/getAlternativeProductApplicationUrl'

type useGetAlternativeProductApplicationUrlReturn = (
    productCode: string
) => string

const useGetAlternativeProductApplicationUrl =
    (): useGetAlternativeProductApplicationUrlReturn => {
        const appConfig = getAppConfig()
        const { appQueryState } = useAppQueryState()
        const trackingData = getMarketingTrackingData(appQueryState)

        const { ids } = useBasin()

        const memoizedGetAlternativeProductApplicationUrl = React.useCallback(
            (productCode: string) => {
                return getAlternativeProductApplicationUrl({
                    clickSource: appConfig.CLICK_SOURCE_WHITELABEL,
                    productCode: productCode,
                    visitGuid: ids?.sessionId!,
                    customerId: appQueryState.customerId!,
                    scoreId: appQueryState.scoreId!,
                    isKnownCustomer: appQueryState.isKnownCustomer!,

                    ...trackingData,
                })
            },
            [
                appQueryState.customerId,
                appQueryState.scoreId,
                appQueryState.isKnownCustomer,
                trackingData,
                ids?.sessionId,
            ]
        )

        return memoizedGetAlternativeProductApplicationUrl
    }

export default useGetAlternativeProductApplicationUrl
